export default __webpack_public_path__ + "static/media/fundo2.4a9d8209.jpg";